import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  returnCode: {
    name: "returnCode",
    label: "Return Code",
    type: "text",
    errorMsg: "Return Code is required.",
    required: true,
    editable: false,
    maxLength: 20,
  },
  description1: {
    name: "description1",
    label: "Description 1",
    type: "text",
    maxLength: 100,
  },
  description2: {
    name: "description2",
    label: "Description 2",
    type: "text",
    maxLength: 100,
  },
};

const { returnCode, description1, description2 } = formField;

export const formRender = [[returnCode], [description1], [description2]];

export const initialValues = getInitialValues(formField);

export const coReturnCodeValidation = Yup.object().shape({
  [returnCode.name]: Yup.string().nullable().max(returnCode.maxLength).required(returnCode.errorMsg),
  [description1.name]: Yup.string().nullable().max(description1.maxLength),
  [description2.name]: Yup.string().nullable().max(description2.maxLength),
});
